import { firestore } from "../index.js"

const editSessionDetails = ({userId, sessionId, field, value}) => {
    const updatingData = {};
    updatingData[field] = value;
    return firestore.collection('users').doc(userId).collection('sessions').doc(sessionId).update(updatingData);
};
export default editSessionDetails;